<template>
  <div class="notice" :class="cssClass">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ui-notice",
  props: { type: { required: false, default: "info" } },
  computed: {
    cssClass: function() {
      return "notice--" + this.type;
    }
  }
};
</script>
<style lang="scss">
.notice {
  border-radius: $radius;
  padding: 10px 10px;
  &--error {
    color: $red;
    border: 1px solid $red;
  }
  &--success {
    color: $green;
    border: 1px solid $green;
  }
}
</style>
